// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';


export default {

    async getSite({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/sites/${id}`, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },   
    
    async getSiteByCompany({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/sites/by-company/${id}`, config);
            commit('updateSitesList', response.data)
            return response.data;
        } catch (error) {
            return error;
        }
    },


    async getSites({ commit, state, rootState, rootGetters }, { id }) {
        try {
            // Получаем токен из состояния хранилища
            const access_token = rootGetters.access_token;


            // Создаем объект конфигурации для запроса с заголовком авторизации
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            // Выполняем GET запрос с использованием Axios и передаем конфигурацию
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/sites`, config);

            // Возвращаем данные ответа
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {

            if (error.status === 401) {

            }

            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

    async fetchSitesList(ctx){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/sites`, config);
            ctx.commit('updateSitesList', response.data) ;
        } catch (error) {
            return error;
        }
    },
    
    async saveCurrentSiteFilter({commit}, site){
        localStorage.setItem('currentSite', JSON.stringify(site))
        commit('updateCurrentSite', site)
    },
    async getCurrentSiteFilter({commit}){
        let site = localStorage.getItem('currentSite')
        if(site){
            site = JSON.parse(site)
            commit('updateCurrentSite', site)
        }
    },
    
    async createSite({ commit, state, rootState, rootGetters }, payload) {

        const access_token = rootGetters.access_token;

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/sites`,
                {
                    name: payload.name,
                    company_id: payload.company_id,
                    lat: payload.lat,
                    lon: payload.lon,
                    tz: payload.tz,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );


            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

    async updateSite({ commit, state, rootState, rootGetters }, payload) {

        const access_token = rootGetters.access_token;

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/sites/${payload.id}`,
                {
                    name: payload.name,
                    company_id: payload.company_id,
                    lat: payload.lat,
                    lon: payload.lon,
                    tz: payload.tz,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );

            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    }


};
